import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './styles/Navbar.css';

const Navbar = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navbarRef = React.useRef(null);

  useEffect(() => {
    const navbar = navbarRef.current;
    if (!navbar) return;

    const handleMouseMove = (e) => {
      const rect = navbar.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      // Update filter turbulence based on mouse position
      const filter = document.querySelector('#glass-distortion feDisplacementMap');
      if (filter) {
        const scaleX = (x / rect.width) * 100;
        const scaleY = (y / rect.height) * 100;
        filter.setAttribute('scale', Math.min(scaleX, scaleY));
      }
      
      // Add highlight effect
      const specular = navbar.querySelector('.glass-specular');
      if (specular) {
        specular.style.background = `radial-gradient(
          circle at ${x}px ${y}px,
          rgba(255,255,255,0.15) 0%,
          rgba(255,255,255,0.05) 30%,
          rgba(255,255,255,0) 60%
        )`;
      }
    };

    const handleMouseLeave = () => {
      const filter = document.querySelector('#glass-distortion feDisplacementMap');
      if (filter) {
        filter.setAttribute('scale', '77');
      }
      
      const specular = navbar.querySelector('.glass-specular');
      if (specular) {
        specular.style.background = 'none';
      }
    };

    navbar.addEventListener('mousemove', handleMouseMove);
    navbar.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      navbar.removeEventListener('mousemove', handleMouseMove);
      navbar.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <>
      <svg style={{ display: 'none' }}>
        <filter id="glass-distortion">
          <feTurbulence type="turbulence" baseFrequency="0.008" numOctaves="2" result="noise" />
          <feDisplacementMap in="SourceGraphic" in2="noise" scale="77" />
        </filter>
      </svg>

      <nav ref={navbarRef} className="glass-navbar">
        
        <div className="glass-navbar-inner">
          <div className="glass-filter"></div>
          <div className="glass-overlay"></div>
          <div className="glass-specular"></div>
          <div className="bottom-glow"></div>
          <div className="glass-content">
            <div className="nav-list">
              <div className="flex items-center justify-between w-full px-4">
                <div className="hidden sm:flex items-center space-x-6">
                  <Link to='/' className={`nav-item ${pathname === '/' ? 'active' : ''}`}>Home</Link>
                  <Link to='/about' className={`nav-item ${pathname === '/about' ? 'active' : ''}`}>About</Link>
                </div>
                
                <div className="text-2xl font-extrabold items-center">
                  <Link to="/" >Avinash Ranga</Link>
                </div>
                
                <div className="hidden sm:flex items-center space-x-6">
                  <Link to='/projects' className={`nav-item ${pathname === '/projects' ? 'active' : ''}`}>Projects</Link>
                  <Link to='/experience' className={`nav-item ${pathname === '/experience' ? 'active' : ''}`}>Experience</Link>
                  <Link to='/contact' className={`nav-item ${pathname === '/contact' ? 'active' : ''}`}>Contact</Link>
                </div>

                <div className="sm:hidden">
                  <button onClick={toggleMobileMenu} className="nav-item focus:outline-none">
                    {isMobileMenuOpen ? '✕' : '☰'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={`sm:hidden fixed top-0 left-0 w-full h-full mobile-menu text-center ${isMobileMenuOpen ? 'flex flex-col items-center justify-center' : 'hidden'}`}>
          <button onClick={closeMobileMenu} className="text-xl absolute top-4 right-4 focus:outline-none">
            ✕
          </button>
          <ul className="font-medium text-2xl space-y-4">
            <li><Link to='/' onClick={closeMobileMenu}>Home</Link></li>
            <li><Link to='/about' onClick={closeMobileMenu}>About</Link></li>
            <li><Link to='/projects' onClick={closeMobileMenu}>Projects</Link></li>
            <li><Link to='/experience' onClick={closeMobileMenu}>Experience</Link></li>
            <li><Link to='/contact' onClick={closeMobileMenu}>Contact</Link></li>
          </ul>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
